import { Formik, Form, FieldArray, useFormikContext } from "formik";
import { useEffect, useState } from "react";
import { RiSaveFill } from "react-icons/ri";
import { RiCloseLargeFill } from "react-icons/ri";
import { FaEdit } from "react-icons/fa";
import { Tooltip as ReactTooltip } from "react-tooltip";
import styled from "styled-components";
import FormikInput from "../../Formik/FormikInput";
import FormikSelect from "../../Formik/FormikSelect";

const FormikAutoFillEffect = ({ selectedShipping }) => {
  const { setFieldValue } = useFormikContext();

  useEffect(() => {
    if (selectedShipping) {
      Object.keys(selectedShipping).forEach((key) => {
        setFieldValue(key, selectedShipping[key]);
      });
    }
  }, [selectedShipping, setFieldValue]);

  return null;
};

const AuthenticatedCheckoutForm = ({
  checkoutFormInitialValues,
  checkoutFormValidationSchema,
  handleSaveAddress,
  selectedShipping,
  setSelectedShipping,
  disabled,
  setDisabled,
  isBilling,
  setIsBilling,
  setIsAddAddress,
  theme,
  statesOption,
  countriesOption,
  getStates,
}) => {
  const { billing_country } = checkoutFormInitialValues;

  useEffect(() => {
    if (billing_country) {
      const selectedCountry = countriesOption.find(
        (country) => country.value === billing_country
      );

      if (selectedCountry) {
        getStates(selectedCountry.value);
      }
    }
  }, [billing_country, countriesOption]);
  return (
    <Formik
      initialValues={{
        ...checkoutFormInitialValues,
      }}
      validationSchema={checkoutFormValidationSchema}
      onSubmit={(values) => handleSaveAddress(values)}
    >
      {({ values, setFieldValue }) => (
        <Form>
          {/* {console.log("values billing", values)} */}
          <FormikAutoFillEffect selectedShipping={selectedShipping} />

          <ContactInfoTitle>2. Billing Address</ContactInfoTitle>
          <div
            className="card d-flex flex-column align-items-start justify-content-center p-3 my-3"
            onClick={() =>
              setSelectedShipping({
                id: values?.billing_id,
                name: values?.billing_name,
                email: values?.billing_email,
                phone: values?.billing_phone,
                phone_prefix: values?.billing_phone_prefix,
                company: values?.billing_company_name,
                street: values?.billing_street,
                city: values?.billing_city,
                state_id: values?.billing_state,
                state: values?.billing_state_name,
                zip: values?.billing_zip,
                country_id: values?.billing_country,
                country: values?.billing_country_name,
              })
            }
            style={{
              width: "fit-content",
              border:
                selectedShipping?.id === values?.billing_id
                  ? `2px solid ${theme.primaryColor.primary}`
                  : "",
              borderRadius: "0.15rem",
            }}
          >
            <span>
              {values?.billing_company_name &&
                `${values.billing_company_name}, `}
              {values?.billing_name}
            </span>
            <span>{values?.billing_street}</span>
            <span>
              {values?.billing_city}, {values?.billing_state_name},{" "}
              {values?.billing_zip}
            </span>
            <span>{values?.billing_country_name}</span>
            <button
              type="button"
              className="d-flex justify-content-center align-items-center mt-2"
              onClick={() => {
                setIsBilling(true);
                setDisabled(true);
                setIsAddAddress(false);
              }}
              style={{
                background: `${theme.primaryColor.secondary}`,
                color: `${theme.primaryColor.primary}`,
                cursor: "pointer",
                borderRadius: "0.15rem",
                fontFamily: "Outfit, sans-serif",
              }}
            >
              <FaEdit className="mx-1" /> Edit
            </button>
          </div>

          <ContactInfoTitle>3. Shipping Addresses</ContactInfoTitle>
          <div
            className="my-3"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(300px, 0fr))",
              gap: "10px",
              justifyContent: "start",
              alignItems: "start",
            }}
          >
            {values.shipping_addresses.map((address, index) => (
              <div
                key={index}
                className="card d-flex flex-column align-items-start justify-content-center p-3"
                onClick={() =>
                  setSelectedShipping({
                    id: address.shipping_id,
                    name: address.shipping_name,
                    email: address.shipping_email,
                    phone: address.shipping_phone,
                    phone_prefix: address.shipping_phone_prefix,
                    company: address.shipping_company_name,
                    street: address.shipping_street,
                    city: address.shipping_city,
                    state_id: address.shipping_state,
                    state: address.shipping_state_name,
                    zip: address.shipping_zip,
                    country_id: address.shipping_country,
                    country: address.shipping_country_name,
                  })
                }
                style={{
                  width: "fit-content",
                  border:
                    selectedShipping?.id === address.shipping_id
                      ? `2px solid ${theme.primaryColor.primary}`
                      : "",
                  borderRadius: "0.15rem",
                }}
              >
                <span>
                  {values?.billing_name}, {address?.shipping_name}
                </span>
                <span>{address?.shipping_street}</span>
                <span>
                  {address?.shipping_city}, {address?.shipping_state_name},{" "}
                  {address?.shipping_zip}
                </span>
                <span>{address?.shipping_country_name}</span>

                <button
                  type="button"
                  className="d-flex justify-content-center align-items-center mt-2"
                  onClick={() => {
                    setDisabled(false);
                    setIsBilling(false);
                    setIsAddAddress(false);
                  }}
                  style={{
                    background: `${theme.primaryColor.secondary}`,
                    color: `${theme.primaryColor.primary}`,
                    cursor: "pointer",
                    borderRadius: "0.15rem",
                    fontFamily: "Outfit, sans-serif",
                  }}
                >
                  <FaEdit className="mx-1" /> Edit
                </button>
              </div>
            ))}
          </div>
          {isBilling && (
            <div className="row">
              <div className="my-3 col-md-6 col-12">
                <FormikInput
                  name="billing_name"
                  value={values.billing_name}
                  onChange={(e) =>
                    setFieldValue("billing_name", e.target.value)
                  }
                  style={{ backgroundColor: "#fff", minHeight: "58px" }}
                  data-tooltip-id="billing_name"
                  data-tooltip-content="Billing Name"
                />
                <ReactTooltip id="billing_name" type="dark" effect="solid" />
              </div>
              <div className="my-3 col-md-6 col-12">
                <FormikInput
                  name="billing_phone"
                  value={values.billing_phone}
                  onChange={(e) =>
                    setFieldValue("billing_phone", e.target.value)
                  }
                  style={{ backgroundColor: "#fff", minHeight: "58px" }}
                  data-tooltip-id="billing_phone"
                  data-tooltip-content="Billing Phone"
                />
                <ReactTooltip id="billing_phone" type="dark" effect="solid" />
              </div>
              <div className="my-3 col-md-6 col-12">
                <FormikInput
                  name="billing_company_name"
                  value={values.billing_company_name}
                  onChange={(e) =>
                    setFieldValue("billing_company_name", e.target.value)
                  }
                  style={{ backgroundColor: "#fff", minHeight: "58px" }}
                  data-tooltip-id="billing_company_name"
                  data-tooltip-content="Billing Company"
                />
                <ReactTooltip
                  id="billing_company_name"
                  type="dark"
                  effect="solid"
                />
              </div>
              <div className="my-3 col-md-6 col-12">
                <FormikInput
                  name="billing_street"
                  value={values.billing_street}
                  onChange={(e) =>
                    setFieldValue("billing_street", e.target.value)
                  }
                  style={{ backgroundColor: "#fff", minHeight: "58px" }}
                  data-tooltip-id="billing_street"
                  data-tooltip-content="Billing Street"
                />
                <ReactTooltip id="billing_street" type="dark" effect="solid" />
              </div>
              <div className="my-3 col-md-4 col-12">
                <FormikInput
                  name="billing_city"
                  value={values.billing_city}
                  onChange={(e) =>
                    setFieldValue("billing_city", e.target.value)
                  }
                  style={{ backgroundColor: "#fff", minHeight: "58px" }}
                  data-tooltip-id="billing_city"
                  data-tooltip-content="Billing City"
                />
                <ReactTooltip id="billing_city" type="dark" effect="solid" />
              </div>
              <div className="my-3 col-md-4 col-12">
                <FormikSelect
                  name="billing_state"
                  options={statesOption}
                  placeholder="Billing State"
                  onChange={(option) => {
                    setFieldValue("billing_state", option.value);
                    setFieldValue("billing_state_name", option.label);
                  }}
                />
              </div>
              <div className="my-3 col-md-4 col-12">
                <FormikInput
                  name="billing_zip"
                  value={values.billing_zip}
                  onChange={(e) => setFieldValue("billing_zip", e.target.value)}
                  style={{ backgroundColor: "#fff", minHeight: "58px" }}
                  data-tooltip-id="billing_zip"
                  data-tooltip-content="Billing Zip"
                />
                <ReactTooltip id="billing_zip" type="dark" effect="solid" />
              </div>
              <div className="my-3 col-md-6 col-12">
                <FormikSelect
                  name="billing_country"
                  options={countriesOption}
                  placeholder="Billing Country"
                  onChange={(option) => {
                    setFieldValue("billing_country", option.value);
                    setFieldValue("billing_country_name", option.label);
                    setFieldValue(
                      "billing_phone_prefix",
                      option.phone_code || "968"
                    );
                    getStates(option.value);
                  }}
                />
              </div>
              <div className="col-12 d-flex align-items-center justify-content-start gap-2 mt-3">
                <button
                  type="button"
                  className="d-flex justify-content-center align-items-center"
                  onClick={() => {
                    handleSaveAddress(values);
                    setIsBilling(false);
                  }}
                  style={{
                    background: `${theme.primaryColor.secondary}`,
                    color: `${theme.primaryColor.primary}`,
                    cursor: "pointer",
                    borderRadius: "0.15rem",
                    fontFamily: "Outfit, sans-serif",
                    minHeight: "58px",
                    borderRadius: "0.15rem",
                  }}
                >
                  <RiSaveFill className="mx-1" />
                  Save changes
                </button>
                <button
                  type="button"
                  className="d-flex justify-content-center align-items-center"
                  onClick={() => {
                    setIsBilling(false);
                    setDisabled(true);
                  }}
                  style={{
                    background: "transparent",
                    color: `${theme.primaryColor.primary}`,
                    border: `1px solid ${theme.primaryColor.primary}`,
                    borderRadius: "0.15rem",
                    fontFamily: "Outfit, sans-serif",
                    minHeight: "58px",
                    borderRadius: "0.15rem",
                  }}
                >
                  <RiCloseLargeFill className="mx-1" />
                  Cancel
                </button>
              </div>
            </div>
          )}

          <FieldArray name="shipping_addresses">
            {() => (
              <div>
                {values.shipping_addresses.map((address, index) =>
                  selectedShipping?.id === address.shipping_id && !disabled ? (
                    <div key={index} className="row">
                      <div className="my-3 col-md-6 col-12">
                        <FormikInput
                          name={`shipping_addresses.${index}.shipping_name`}
                          value={address?.shipping_first_name || ""}
                          style={{
                            backgroundColor: "#fff",
                            minHeight: "58px",
                            borderRadius: "0.15rem",
                          }}
                          onChange={(e) =>
                            setFieldValue(
                              `shipping_addresses.${index}.shipping_name`,
                              e.target.value
                            )
                          }
                          data-tooltip-id="nameTooltip"
                          data-tooltip-content="Shipping Name"
                        />
                        <ReactTooltip
                          id="nameTooltip"
                          type="dark"
                          effect="solid"
                        />
                      </div>
                      <div className="my-3 col-md-6 col-12 d-flex">
                        <FormikInput
                          name={`shipping_addresses.${index}.shipping_phone_prefix`}
                          inputClassName="shipping-phone-prefix"
                          readOnly
                        />
                        <div className="d-flex flex-column w-100">
                          <FormikInput
                            name={`shipping_addresses.${index}.shipping_phone`}
                            type="number"
                            inputClassName="shipping-phone"
                            value={address?.shipping_phone}
                            style={{
                              backgroundColor: "#fff",
                              minHeight: "58px",
                              borderRadius: "0.15rem",
                            }}
                            onChange={(e) =>
                              setFieldValue(
                                `shipping_addresses.${index}.shipping_phone`,
                                e.target.value
                              )
                            }
                            data-tooltip-id="phoneTooltip"
                            data-tooltip-content="Shipping Phone"
                          />
                          <ReactTooltip
                            id="phoneTooltip"
                            type="dark"
                            effect="solid"
                          />
                        </div>
                      </div>
                      <div className="my-3 col-12">
                        <FormikInput
                          name={`shipping_addresses.${index}.shipping_street`}
                          value={address.shipping_street}
                          style={{
                            backgroundColor: "#fff",
                            minHeight: "58px",
                            borderRadius: "0.15rem",
                          }}
                          onChange={(e) =>
                            setFieldValue(
                              `shipping_addresses.${index}.shipping_street`,
                              e.target.value
                            )
                          }
                          data-tooltip-id="streetTooltip"
                          data-tooltip-content="Shipping Street"
                        />
                        <ReactTooltip
                          id="streetTooltip"
                          type="dark"
                          effect="solid"
                        />
                      </div>
                      <div className="my-3 col-md-3 col-12">
                        <FormikInput
                          name={`shipping_addresses.${index}.shipping_city`}
                          value={address?.shipping_city}
                          style={{
                            backgroundColor: "#fff",
                            minHeight: "58px",
                            borderRadius: "0.15rem",
                          }}
                          onChange={(e) =>
                            setFieldValue(
                              `shipping_addresses.${index}.shipping_city`,
                              e.target.value
                            )
                          }
                          data-tooltip-id="cityTooltip"
                          data-tooltip-content="Shipping City"
                        />
                        <ReactTooltip
                          id="cityTooltip"
                          type="dark"
                          effect="solid"
                        />
                      </div>
                      <div className="my-3 col-md-3 col-12">
                        <FormikSelect
                          name={`shipping_addresses.${index}.shipping_state`}
                          borderStyle={true}
                          onChange={(option) =>
                            setFieldValue(
                              `shipping_addresses.${index}.shipping_zip`,
                              option.zip || ""
                            )
                          }
                          options={statesOption}
                          placeholder={"State"}
                        />
                      </div>
                      <div className="my-3 col-md-3 col-12">
                        <FormikInput
                          name={`shipping_addresses.${index}.shipping_zip`}
                          value={address?.shipping_zip}
                          style={{
                            backgroundColor: "#fff",
                            minHeight: "58px",
                            borderRadius: "0.15rem",
                          }}
                          disabled={true}
                          onChange={(e) =>
                            setFieldValue(
                              `shipping_addresses.${index}.shipping_zip`,
                              e.target.value
                            )
                          }
                          data-tooltip-id="zipTooltip"
                          data-tooltip-content="Shipping Zip"
                        />
                        <ReactTooltip
                          id="zipTooltip"
                          type="dark"
                          effect="solid"
                        />
                      </div>
                      <div className="my-3 col-md-3 col-12">
                        <FormikSelect
                          name={`shipping_addresses.${index}.shipping_country`}
                          borderStyle={true}
                          onChange={(option) => {
                            setFieldValue(
                              `shipping_addresses.${index}.shipping_phone_prefix`,
                              option.phone_code || "968"
                            );
                            getStates(option.value);
                          }}
                          options={countriesOption}
                          placeholder={"Country"}
                        />
                      </div>

                      <div className="col-12 mt-3 d-flex align-items-center justify-content-start gap-2">
                        <button
                          type="button"
                          className="d-flex justify-content-center align-items-center"
                          onClick={() => {
                            handleSaveAddress(values);
                            setDisabled(true);
                          }}
                          style={{
                            background: `${theme.primaryColor.secondary}`,
                            color: `${theme.primaryColor.primary}`,
                            cursor: "pointer",
                            borderRadius: "0.15rem",
                            fontFamily: "Outfit, sans-serif",
                            minHeight: "58px",
                            borderRadius: "0.15rem",
                          }}
                        >
                          <RiSaveFill
                            className="mx-1"
                            style={{ fontWeight: "bold" }}
                          />
                          Save changes
                        </button>
                        <button
                          type="button"
                          className="d-flex justify-content-center align-items-center"
                          onClick={() => {
                            setIsBilling(false);
                            setDisabled(true);
                          }}
                          style={{
                            background: "transparent",
                            color: `${theme.primaryColor.primary}`,
                            border: `1px solid ${theme.primaryColor.primary}`,
                            cursor: "pointer",
                            borderRadius: "0.15rem",
                            fontFamily: "Outfit, sans-serif",
                            minHeight: "58px",
                            borderRadius: "0.15rem",
                          }}
                        >
                          <RiCloseLargeFill className="mx-1" />
                          Cancel
                        </button>
                      </div>
                    </div>
                  ) : null
                )}
              </div>
            )}
          </FieldArray>
        </Form>
      )}
    </Formik>
  );
};

export default AuthenticatedCheckoutForm;

const ContactInfoTitle = styled.div`
  font-family: Outfit, sans-serif;
  display: flex;
  align-items: center;
  justify-content: start;
  width: 100%;
  font-weight: bold;
  padding: 10px;
  font-size: 20px;
  border-bottom: 2px solid #9c9a9a;
  color: #666666;
`;
